import { Card } from 'react-bootstrap';
import PaymentRequests from './partials/PaymentRequests';
import Payments from './partials/Payments';

function Index(props) {

    return (
        <>
            <Card className="mb-3">
                <Card.Header>
                    Плащания по клиентската заявка
                </Card.Header>
                <Card.Body>
                    <Payments
                        id={props.id}
                        showPayment={props.showPayment}
                    />
                </Card.Body>
            </Card>

            <Card className="">
                <Card.Header>
                    Заявки за плащане
                </Card.Header>
                <Card.Body>
                    <PaymentRequests
                        id={props.id}
                    />
                </Card.Body>
            </Card>
        </>
    )
}

export default Index;